module.exports = __webpack_public_path__ + "img/19_36.72f4fafb.png";